import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';

export const UserWrapper = styled.div`
  background: #171717;
`;

export const CollectionUserWrapper = styled.div`
  ${mediaDesktop} {
    padding-top: 0;
  }
`;
